export const Float = {
  MaxValue: 3.4028234663852886e38,
  MinValue: 3.4028234663852886e38,
  Eplison: Number.EPSILON,
} as const
